(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-perfume-bundle"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('perfume-bundle')) {

  class PerfumeBundle extends HTMLElement {

    connectedCallback() {

      if (this.dataset.initialized === 'true') {

        return;

      }

      this.dataset.initialized = 'true';

      this.currency =

        this.dataset.currency || 'USD';

      this.addUrl =

        this.dataset.addUrl;

      this.cartUrl =

        this.dataset.cartUrl;

      this.minItems = 2;

      this.maxItems = 5;

      this.addButton =

        this.querySelector(

          '[data-add-bundle]'

        );

      this.message =

        this.querySelector(

          '[data-message]'

        );

      this.selectionCount =

        this.querySelector(

          '[data-selection-count]'

        );

      this.discountBadge =

        this.querySelector(

          '[data-discount-badge]'

        );

      this.tierMessage =

        this.querySelector(

          '[data-tier-message]'

        );

      this.searchInput =

        this.querySelector(

          '[data-bundle-search]'

        );

      this.searchClear =

        this.querySelector(

          '[data-search-clear]'

        );

      this.searchMessage =

        this.querySelector(

          '[data-search-message]'

        );

      this.grid =

        this.querySelector(

          '.pb-products'

        );

      this.cards =

        Array.from(

          this.querySelectorAll(

            '[data-product-card]'

          )

        );

      this.displayLimit =

        Math.max(

          1,

          Number(this.dataset.displayLimit || 4)

        );

      this.sectionId =

        this.dataset.sectionId || '';

      this.totalProducts =

        Math.max(

          0,

          Number(this.dataset.totalProducts || this.cards.length)

        );

      this.totalPages =

        Math.max(

          1,

          Number(this.dataset.totalPages || 1)

        );

      this.allProductsLoaded =

        this.totalPages <= 1;

      this.loadAllPromise = null;

      this.searchLoadError = false;

      this.bindCards(this.cards);

      /* SEARCH */

      if (this.searchInput) {

        this.searchInput.addEventListener(

          'input',

          () => this.handleSearchInput()

        );

      }

      if (this.searchClear) {

        this.searchClear.addEventListener(

          'click',

          () => {

            if (!this.searchInput) {

              return;

            }

            this.searchInput.value = '';

            this.filterProducts();

            this.searchInput.focus();

          }

        );

      }

      /* ADD BUNDLE */

      if (this.addButton) {

        this.addButton.addEventListener(

          'click',

          () => this.addBundle()

        );

      }

      this.filterProducts();

      this.updateTotals();

    }

    /* =========================

       SEARCH / PRODUCT DISPLAY

    ========================= */

    bindCards(cards) {

      cards.forEach((card) => {

        const button =

          card.querySelector(

            '[data-select-product]'

          );

        if (

          button &&

          button.dataset.pbBound !== 'true'

        ) {

          button.dataset.pbBound = 'true';

          button.addEventListener(

            'click',

            () => {

              this.toggleProduct(

                card,

                button

              );

            }

          );

        }

        const select =

          card.querySelector(

            '[data-variant-select]'

          );

        if (

          select &&

          select.dataset.pbBound !== 'true'

        ) {

          select.dataset.pbBound = 'true';

          select.addEventListener(

            'change',

            () => {

              this.updateCardFromSelect(

                select

              );

              this.updateTotals();

            }

          );

        }

      });

    }

    async handleSearchInput() {

      const query =

        this.searchInput

          ? this.searchInput.value.trim()

          : '';

      if (

        query &&

        !this.allProductsLoaded

      ) {

        await this.ensureAllProductsLoaded();

      }

      this.filterProducts();

    }

    async ensureAllProductsLoaded() {

      if (

        this.allProductsLoaded ||

        this.totalPages <= 1 ||

        !this.sectionId ||

        !this.grid

      ) {

        return;

      }

      if (this.loadAllPromise) {

        return this.loadAllPromise;

      }

      this.searchLoadError = false;

      if (this.searchMessage) {

        this.searchMessage.hidden = false;

        this.searchMessage.textContent =

          `Searching all ${this.totalProducts} fragrances…`;

      }

      this.loadAllPromise =

        (async () => {

          const pages = [];

          for (

            let page = 2;

            page <= this.totalPages;

            page += 1

          ) {

            pages.push(page);

          }

          const results =

            await Promise.all(

              pages.map(

                (page) =>

                  this.fetchProductPage(page)

              )

            );

          const existingIds =

            new Set(

              this.cards.map(

                (card) =>

                  card.dataset.productId

              ).filter(Boolean)

            );

          results.forEach((pageCards) => {

            pageCards.forEach((card) => {

              const productId =

                card.dataset.productId;

              if (

                productId &&

                existingIds.has(productId)

              ) {

                return;

              }

              if (productId) {

                existingIds.add(productId);

              }

              card.hidden = true;

              this.grid.appendChild(card);

              this.cards.push(card);

              this.bindCards([card]);

            });

          });

          this.allProductsLoaded = true;

        })()

        .catch((error) => {

          console.error(

            'Bundle & Save collection search failed:',

            error

          );

          this.searchLoadError = true;

        })

        .finally(() => {

          this.loadAllPromise = null;

        });

      return this.loadAllPromise;

    }

    async fetchProductPage(page) {

      const url =

        new URL(window.location.href);

      url.searchParams.delete('sections');

      url.searchParams.set(

        'section_id',

        this.sectionId

      );

      url.searchParams.set(

        'page',

        String(page)

      );

      const response =

        await fetch(

          url.toString(),

          {

            headers: {

              'X-Requested-With':

                'XMLHttpRequest'

            }

          }

        );

      if (!response.ok) {

        throw new Error(

          `Unable to load collection page ${page}.`

        );

      }

      const html =

        await response.text();

      const documentFragment =

        new DOMParser().parseFromString(

          html,

          'text/html'

        );

      return Array.from(

        documentFragment.querySelectorAll(

          '[data-product-card]'

        )

      );

    }

    filterProducts() {

      const query =

        this.searchInput

          ? this.searchInput.value

              .trim()

              .toLowerCase()

          : '';

      let matchedCount = 0;

      let visibleCount = 0;

      this.cards.forEach((card) => {

        const searchText =

          (

            card.dataset.searchText ||

            card.dataset.productTitle ||

            ''

          ).toLowerCase();

        const matches =

          !query ||

          searchText.includes(query);

        if (matches) {

          matchedCount += 1;

        }

        const shouldShow =

          query

            ? matches

            : matches && visibleCount < this.displayLimit;

        card.hidden =

          !shouldShow;

        if (shouldShow) {

          visibleCount += 1;

        }

      });

      if (this.searchClear) {

        this.searchClear.hidden =

          !query;

      }

      if (this.searchMessage) {

        if (

          query &&

          this.searchLoadError

        ) {

          this.searchMessage.hidden =

            false;

          this.searchMessage.textContent =

            'Search could not load the entire collection. Please try again.';

        }

        else if (!query) {

          this.searchMessage.hidden =

            true;

          this.searchMessage.textContent =

            '';

        }

        else if (matchedCount === 0) {

          this.searchMessage.hidden =

            false;

          this.searchMessage.textContent =

            'No fragrances found.';

        }

        else {

          this.searchMessage.hidden =

            false;

          this.searchMessage.textContent =

            `${matchedCount} ${matchedCount === 1 ? 'fragrance' : 'fragrances'} found.`;

        }

      }

    }

    /* =========================

       TOGGLE PRODUCT

    ========================= */

    toggleProduct(card, button) {

      if (!card || !button) {

        return;

      }

      const currentlySelected =

        card.dataset.selected === 'true';

      const selectedCards =

        this.getSelectedCards();

      if (

        !currentlySelected &&

        selectedCards.length >= this.maxItems

      ) {

        this.setMessage(

          'You can select a maximum of 5 fragrances.'

        );

        return;

      }

      if (

        !currentlySelected &&

        card.dataset.currentAvailable !== 'true'

      ) {

        this.setMessage(

          'This fragrance is currently unavailable.'

        );

        return;

      }

      card.dataset.selected =

        currentlySelected

          ? 'false'

          : 'true';

      button.setAttribute(

        'aria-pressed',

        currentlySelected

          ? 'false'

          : 'true'

      );

      this.setMessage('');

      this.updateTotals();

    }

    /* =========================

       VARIANT UPDATE

    ========================= */

    updateCardFromSelect(select) {

      const card =

        select.closest(

          '[data-product-card]'

        );

      const option =

        select.options[

          select.selectedIndex

        ];

      if (!card || !option) {

        return;

      }

      card.dataset.currentVariant =

        option.value;

      card.dataset.currentPrice =

        option.dataset.price || '0';

      card.dataset.currentAvailable =

        option.dataset.available || 'false';

      const priceElement =

        card.querySelector(

          '[data-card-price]'

        );

      if (priceElement) {

        priceElement.textContent =

          this.formatMoney(

            Number(

              option.dataset.price || 0

            )

          );

      }

      if (

        card.dataset.currentAvailable !== 'true' &&

        card.dataset.selected === 'true'

      ) {

        card.dataset.selected =

          'false';

      }

    }

    /* =========================

       SELECTED PRODUCTS

    ========================= */

    getSelectedCards() {

      return Array.from(

        this.querySelectorAll(

          '[data-product-card][data-selected="true"]'

        )

      );

    }

    getItems() {

      return this

        .getSelectedCards()

        .map((card) => ({

          id:

            Number(

              card.dataset.currentVariant || 0

            ),

          price:

            Number(

              card.dataset.currentPrice || 0

            ),

          available:

            card.dataset.currentAvailable ===

            'true'

        }));

    }

    /* =========================

       DISCOUNT

    ========================= */

    getDiscount(count) {

      if (count >= 4) {

        return 20;

      }

      if (count === 3) {

        return 15;

      }

      if (count === 2) {

        return 10;

      }

      return 0;

    }

    /* =========================

       UPDATE PRODUCT BUTTONS

    ========================= */

    updateSelectionControls(count) {

      this

        .querySelectorAll(

          '[data-product-card]'

        )

        .forEach((card) => {

          const button =

            card.querySelector(

              '[data-select-product]'

            );

          if (!button) {

            return;

          }

          const selected =

            card.dataset.selected ===

            'true';

          const available =

            card.dataset.currentAvailable ===

            'true';

          if (selected) {

            button.textContent =

              'SELECTED ✓';

            button.disabled =

              false;

            button.setAttribute(

              'aria-pressed',

              'true'

            );

          }

          else if (!available) {

            button.textContent =

              'SOLD OUT';

            button.disabled =

              true;

            button.setAttribute(

              'aria-pressed',

              'false'

            );

          }

          else {

            button.textContent =

              'SELECT';

            button.disabled =

              count >= this.maxItems;

            button.setAttribute(

              'aria-pressed',

              'false'

            );

          }

        });

    }

    /* =========================

       TIER DISPLAY

    ========================= */

    updateTierDisplay(

      count,

      discount

    ) {

      this

        .querySelectorAll(

          '[data-tier]'

        )

        .forEach((tier) => {

          tier.classList.remove(

            'is-active'

          );

        });

      let tierValue = null;

      if (count >= 4) {

        tierValue = '4';

      }

      else if (count === 3) {

        tierValue = '3';

      }

      else if (count === 2) {

        tierValue = '2';

      }

      if (tierValue) {

        const tier =

          this.querySelector(

            `[data-tier="${tierValue}"]`

          );

        if (tier) {

          tier.classList.add(

            'is-active'

          );

        }

      }

      if (this.discountBadge) {

        this.discountBadge.classList.toggle(

          'is-unlocked',

          discount > 0

        );

        if (discount > 0) {

          this.discountBadge.textContent =

            `SAVE ${discount}%`;

        }

        else {

          this.discountBadge.textContent =

            'SELECT 2+ TO SAVE';

        }

      }

      if (!this.tierMessage) {

        return;

      }

      if (count === 0) {

        this.tierMessage.textContent =

          'Select 2 fragrances to unlock 10% off.';

      }

      else if (count === 1) {

        this.tierMessage.textContent =

          'Add 1 more fragrance to unlock 10% off.';

      }

      else if (count === 2) {

        this.tierMessage.textContent =

          '10% off unlocked — add 1 more for 15% off.';

      }

      else if (count === 3) {

        this.tierMessage.textContent =

          '15% off unlocked — add 1 more for 20% off.';

      }

      else if (count === 4) {

        this.tierMessage.textContent =

          '20% off unlocked — maximum discount reached.';

      }

      else {

        this.tierMessage.textContent =

          '20% off unlocked — maximum discount reached.';

      }

    }

    /* =========================

       TOTALS

    ========================= */

    updateTotals() {

      const items =

        this.getItems();

      const count =

        items.length;

      const validCount =

        count >= this.minItems &&

        count <= this.maxItems;

      const allAvailable =

        items.every(

          (item) =>

            item.id &&

            item.available

        );

      const discount =

        this.getDiscount(count);

      const regularTotal =

        items.reduce(

          (sum, item) =>

            sum + item.price,

          0

        );

      const savings =

        Math.round(

          regularTotal *

          (discount / 100)

        );

      const bundleTotal =

        Math.max(

          0,

          regularTotal - savings

        );

      const regularEl =

        this.querySelector(

          '[data-regular-total]'

        );

      const savingsEl =

        this.querySelector(

          '[data-saving-total]'

        );

      const bundleEl =

        this.querySelector(

          '[data-bundle-total]'

        );

      const discountLabel =

        this.querySelector(

          '[data-discount-label]'

        );

      const buttonPriceEl =

        this.querySelector(

          '[data-button-price]'

        );

      /* COUNT */

      if (this.selectionCount) {

        this.selectionCount.textContent =

          count === 1

            ? '1 selected'

            : `${count} selected`;

      }

      /* REGULAR PRICE */

      if (regularEl) {

        regularEl.textContent =

          count > 0

            ? this.formatMoney(

                regularTotal

              )

            : '—';

      }

      /* SAVINGS */

      if (savingsEl) {

        savingsEl.textContent =

          discount > 0

            ? `-${this.formatMoney(

                savings

              )}`

            : '—';

      }

      /* DISCOUNT LABEL */

      if (discountLabel) {

        discountLabel.textContent =

          discount > 0

            ? `Discount (${discount}%)`

            : 'Discount';

      }

      /* BUNDLE TOTAL */

      if (bundleEl) {

        bundleEl.textContent =

          count > 0

            ? this.formatMoney(

                bundleTotal

              )

            : '—';

      }

      /* BUTTON TOTAL */

      if (buttonPriceEl) {

        buttonPriceEl.textContent =

          validCount

            ? this.formatMoney(

                bundleTotal

              )

            : '';

      }

      /* ENABLE BUTTON */

      if (this.addButton) {

        this.addButton.disabled =

          !validCount ||

          !allAvailable;

      }

      this.updateSelectionControls(

        count

      );

      this.updateTierDisplay(

        count,

        discount

      );

    }

    /* =========================

       ADD TO CART

    ========================= */

    async addBundle() {

      const items =

        this.getItems();

      const count =

        items.length;

      const discount =

        this.getDiscount(count);

      if (

        count < this.minItems ||

        count > this.maxItems

      ) {

        this.setMessage(

          'Choose between 2 and 5 fragrances.'

        );

        return;

      }

      if (

        items.some(

          (item) =>

            !item.id ||

            !item.available

        )

      ) {

        this.setMessage(

          'One or more selected fragrances are unavailable.'

        );

        return;

      }

      const labelEl =

        this.addButton.querySelector(

          '[data-button-label]'

        );

      const originalLabel =

        labelEl

          ? labelEl.textContent

          : 'ADD BUNDLE';

      if (labelEl) {

        labelEl.textContent =

          'ADDING...';

      }

      this.addButton.disabled =

        true;

      this.setMessage('');

      try {

        const bundleId =

          `bundle-${Date.now()}`;

        const response =

          await fetch(

            this.addUrl,

            {

              method: 'POST',

              headers: {

                'Content-Type':

                  'application/json',

                'Accept':

                  'application/json'

              },

              body:

                JSON.stringify({

                  items:

                    items.map(

                      (item) => ({

                        id:

                          item.id,

                        quantity:

                          1,

                        properties: {

                          '_Bundle':

                            'Bundle & Save',

                          '_Bundle ID':

                            bundleId,

                          '_Bundle Discount':

                            `${discount}%`

                        }

                      })

                    )

                })

            }

          );

        const data =

          await response

            .json()

            .catch(

              () => ({})

            );

        if (!response.ok) {

          throw new Error(

            data.description ||

            data.message ||

            'Unable to add the bundle.'

          );

        }

        if (labelEl) {

          labelEl.textContent =

            'ADDED ✓';

        }

        this.setMessage(

          'Bundle added to cart.'

        );

        window.setTimeout(

          () => {

            window.location.href =

              this.cartUrl;

          },

          300

        );

      }

      catch (error) {

        if (labelEl) {

          labelEl.textContent =

            originalLabel;

        }

        this.addButton.disabled =

          false;

        this.setMessage(

          error.message ||

          'Something went wrong. Please try again.'

        );

      }

    }

    /* =========================

       MESSAGE

    ========================= */

    setMessage(text) {

      if (!this.message) {

        return;

      }

      this.message.textContent =

        text || '';

    }

    /* =========================

       MONEY

    ========================= */

    formatMoney(cents) {

      try {

        return new Intl.NumberFormat(

          document.documentElement.lang ||

          'en',

          {

            style:

              'currency',

            currency:

              this.currency

          }

        ).format(

          Number(cents || 0) / 100

        );

      }

      catch (error) {

        return `${

          (

            Number(cents || 0) / 100

          ).toFixed(2)

        } ${this.currency}`;

      }

    }

  }

  customElements.define(

    'perfume-bundle',

    PerfumeBundle

  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oudware-fragrance-profile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initOudwareProfile = (section) => {
      if (!section || section.dataset.owProfileInit === 'true') return;
      section.dataset.owProfileInit = 'true';

      const tabs = Array.from(section.querySelectorAll('.ow-profile__nav-item'));
      const panels = Array.from(section.querySelectorAll('.ow-profile__panel'));

      if (!tabs.length || !panels.length) return;

      const activate = (name, focus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.panel === name;

          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');

          if (active && focus) tab.focus();
        });

        panels.forEach((panel) => {
          const active = panel.dataset.panelContent === name;

          if (active) {
            panel.hidden = false;

            requestAnimationFrame(() => {
              panel.classList.add('is-active');
            });
          } else {
            panel.classList.remove('is-active');
            panel.hidden = true;
          }
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          activate(tab.dataset.panel);
        });

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          }

          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== null) {
            event.preventDefault();
            activate(tabs[nextIndex].dataset.panel, true);
          }
        });
      });

      const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];

      if (activeTab) activate(activeTab.dataset.panel);
    };

    const initAll = () => {
      document.querySelectorAll('.ow-profile').forEach(initOudwareProfile);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector
        ? event.target.querySelector('.ow-profile')
        : null;

      if (section) initOudwareProfile(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
